import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';
import { DialogConfirmComponent, DialogConfirmData } from '../../../partials/components/dialog-confirm/dialog-confirm.component';

/**
 * Warns before entering a screen that is not (fully) backed by the 6.3 API.
 *
 * The case list, case detail, flow and signal lifecycle run on real data, but the VASP directory,
 * the event feed and the analytics built on top of them have no endpoints yet — those screens still
 * render the prototype dataset. Without a warning they look exactly like production numbers, so the
 * guard makes the reader acknowledge it before the screen opens; declining returns to the case list.
 */
export function mockDataGuard(description: string, title = 'Demo data'): CanActivateFn {
    return (): Observable<boolean | UrlTree> => {
        const dialog = inject(MatDialog);
        const router = inject(Router);

        const data: DialogConfirmData = {
            variant: 'warning',
            title,
            description,
            confirmLabel: 'Got it, open',
        };

        return dialog
            .open(DialogConfirmComponent, {
                width: '100%',
                maxWidth: '460px',
                backdropClass: 'cdk-overlay-dark-backdrop',
                disableClose: true,
                data,
            })
            .afterClosed()
            .pipe(map(confirmed => confirmed === true ? true : router.createUrlTree(['/case-management/cases'])));
    };
}

export const MOCK_NOTICE = {
    vasp: 'The VASP directory (exchanges, OTC, processing) and its ranking are demo data from the prototype. '
        + 'The backend does not provide them yet, so settings here are not saved anywhere.',
} as const;
